import { Navigate } from 'react-router-dom';
import storage from '../Assets/js/Global';

const PublicRoute = ({ children }) => {
    const is4Life = process.env.REACT_APP_COMPANY_ID === '0it02f';
    const loginObj = storage.get('loginObj');
    const isAuthenticated = loginObj && loginObj.userKey;

    if (isAuthenticated) {
        return <Navigate to={is4Life ? '/dashboard2' : '/dashboard'} replace />;
    }

    return children;
};

export { PublicRoute };